const utils = require("frontend-controller/lib/utils")
module.exports = {
    extends: [
        '/',
        'templates',
        'propertiesForms',
        'componentDataForm',
    ],

    config: {
        resourceRegisterKey: 'nodeData',
        isFieldCodeSelector: true,
        // separatorKey: null,
        // subFormAlias: 'additionalDataFields', // should be set in componentInstance.config
        // separatorMode: 'inline',
        // availableSeparators: {
        //     type: 'single'
        // },
        // parentFormResourceKey: 'attributes', // should be set in componentInstance.config
        // subFormAliasContainer: 'attributes', // should be set in componentInstance.config
    },

    methods: {

        /**
         * initialize component structure based on singe component resource instead of tree resource.
         */
        dataDealer: function(){
            if(!this.model.dataStructure){
                this.model.dataStructure = utils.simpleCopy(this.getResourceRegisterContent(this.config.resourceRegisterKey))
                this.initComponentData(this.model.dataStructure);
                utils.promise.performAllChains(this, this.getPostBuildFieldActions()).then(() => {
                    if (this.$) {
                        this.refresh(false);
                    }
                });
            }
        },
    }
};
